import { PurchasingDocument } from './purchasing-document'
import { PurchasingOrderLineItem } from './purchasing-order-line-item'

export class PurchasingOrder {
    id!: string
    poNumber!: string
    status!: string
    orderType!: string
    job!: string
    equipment!: string
    workOrder!: string
    workOrderItem!: number | undefined
    workOrderId!: string | undefined
    vendor!: number | undefined
    vendorName!: string
    description!: string
    notes!: string
    orderDate!: Date | undefined
    requiredByDate!: Date | undefined
    shipToAddress!: string
    paymentTerms!: string
    subtotal!: number | undefined
    taxAmount!: number | undefined
    freightAmount!: number | undefined
    total!: number | undefined
    source!: string
    quoteId!: string | undefined
    createdBy!: string
    createdByHrRef!: number | undefined
    createdOn!: Date | undefined
    archived!: boolean

    lineItems: PurchasingOrderLineItem[] = []
    documents: PurchasingDocument[] = []
    receiptCount!: number
    invoiceCount!: number
    extractWarning!: string
}
